import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/content";
import HammersBackdrop from "@/components/site/HammersBackdrop";

export default function ServicesGrid() {
  return (
    <section
      id="services"
      className="relative bg-paper py-24 md:py-32 overflow-hidden"
      data-testid="services-section"
    >
      <HammersBackdrop density="light" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 relative z-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#16a34a]">
              What We Do
            </div>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-[#1c1917] mt-2 tracking-tight max-w-2xl">
              Built local. Done right.{" "}
              <span className="text-[#57534e]">Every property service you&rsquo;ll need.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.slug}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.55, delay: i * 0.05 }}
            >
              <Link
                to={`/services/${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className="group block bg-white border border-[#e7e5df] rounded-3xl overflow-hidden hover:-translate-y-1 hover:border-[#16a34a] hover:shadow-xl transition-all duration-300"
              >
                <div className="relative aspect-[4/3] overflow-hidden bg-[#f4f1ea]">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
                </div>
                <div className="p-6">
                  <div className="flex items-start justify-between gap-3">
                    <h3 className="font-display font-extrabold text-xl text-[#1c1917] tracking-tight">
                      {s.title}
                    </h3>
                    <span className="h-9 w-9 rounded-full border border-[#e7e5df] inline-flex items-center justify-center group-hover:bg-[#16a34a] group-hover:border-[#16a34a] group-hover:text-white transition">
                      <ArrowUpRight className="w-4 h-4" />
                    </span>
                  </div>
                  <p className="mt-2 text-[#57534e] text-sm leading-relaxed">
                    {s.short}
                  </p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
